import { render } from "./UnitedOne.vue?vue&type=template&id=6dea15d2"
import script from "./UnitedOne.vue?vue&type=script&lang=js"
export * from "./UnitedOne.vue?vue&type=script&lang=js"

import "./UnitedOne.vue?vue&type=style&index=0&id=6dea15d2&lang=css"
script.render = render

export default script